import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "@vueuse/core"

export const ENGAGEMENT_OVERVIEW_QUERY_KEY =
  "engagement_overview"

export type ScoreDistribution = {
  label: string | number
  count: number
}
export type EngagementOverview = {
  engagementScoreMean: number
  engagementScoreDistribution: ScoreDistribution[]

  transactionScoreMean: number
  transactionScoreDistribution: ScoreDistribution[]
}

export type EngagementOverviewQuery = {
  forMonthStartingOn: string
  currency: string
}

export const retrieveEngagementOverview = async (
  query: EngagementOverviewQuery
) => {
  const { body } = await api.get<EngagementOverview>(
    `/engagement-overview/`,
    { query }
  )

  return body
}

export const useEngagementOverview = (
  query: MaybeRef<EngagementOverviewQuery>,
  enabled: MaybeRef<boolean> = true
) =>
  useQuery({
    queryKey: [
      ENGAGEMENT_OVERVIEW_QUERY_KEY,
      query,
    ] as const,
    enabled,
    queryFn: ({ queryKey: [_, query_] }) =>
      retrieveEngagementOverview(unref(query_)),
  })
